<template>
    <div
        :class="{ line: index == jShow, tenderItem: true }"
        @mouseenter="jMover(index)"
        @mouseleave="jShow = -1"
        @click="goNewDetail('/biddingDetail',item.id,item.state)"
    >
        <div class="head">
            <p class="title" :title="item.name">{{ item.name }}</p>
            <div class="titleInfo">
                <span style="color: #ff6600"
                    >【{{ item.type | tenderType }}】</span
                >
                <!-- <span style="color: #0286df"
                    >{{ item.biddingMethod == 2 ? '【邀请招标】': '【公开招标】'}}</span
                > -->
                <span style="color: #78c06e" v-if="item.verticalTypeName"
                    >【{{ item.verticalTypeName }}】</span
                >
                <span class="moneySpan">
                    预算金额：
                    <span style="color: #ff6600">{{
                        getMoney(item.money)
                    }}</span>
                </span>
            </div>
            <!-- state  一直是8 -->
            <img class="i-status" src="../../../assets/zbyg.png"/>
        </div>
        <div class="body">
            <template v-if="item.type == 6 || item.type == 7 || item.type == 8 || item.type == 9 || item.type == 10 || item.type == 13 || item.type == 20">
                <div class="noshuju">
                    <img src="@/assets/noshuju.png" alt="">
                    <div class="text-info">
                        该类型无招标清单
                    </div>
                </div>
            </template>
            <!-- 3.0 循环表头  -->
            <template v-else>
                <el-table :data="itemData">
                    <el-table-column
                        v-for="(itt,index) in item.goodsHeader"
                        :key="index"
                        :label="itt.translate"
                        :prop="itt.name"
                        show-overflow-tooltip
                    ></el-table-column>
                </el-table>
            </template>
        </div>
        <div class="footer">
            <p v-if="item.applyStartTime">
                <span> 报名开始时间： </span
                >{{ item.applyStartTime | formaHoures }}
            </p>
             <!-- <p v-if="item.tenderState == 8 && item.applyStartTime">
                <span> 报名开始时间： </span
                >{{ item.applyStartTime | formaHoures }}
            </p> -->
            <p v-if="item.tenderState == 9 && item.applyEndTime">
                <span> 报名结束时间： </span
                >{{ item.applyEndTime | formaHoures }}
            </p>
            <p v-if="item.tenderState == 1 && item.startTime">
                <span> 投标开始时间： </span>{{ item.startTime | formaHoures }}
            </p>
            <p v-if="item.tenderState == 3 && item.bidTime">
                <span> 开标时间： </span>{{ item.bidTime | formaHoures }}
            </p>
            <p v-if="item.tenderState == 4 && item.winningTime">
                <span> 定标时间： </span>{{ item.winningTime | formaHoures }}
            </p>
            <p v-if="item.tenderState == 2 && item.endTime">
                <span> 投标结束时间： </span>{{ item.endTime | formaHoures }}
            </p>
            <p v-if="item.comName">
                <span> 招标企业： </span>{{ item.comName }}
            </p>
            <p v-if="item.region">
                <img src="@/assets/tender/areaImg.png" alt="" /><span>
                    地址： </span
                >{{ item.region + item.address}}
            </p>
        </div>
        <jPop
            v-if="index == jShow"
            :item="item"
            :jIndex="index"
            :type='type'
            @inByLetDialogClick="inByLetDialogClick"
        ></jPop>
    </div>
</template>
<script>
import apiIln from "@/api/zhaocai/apiLnquiryLetter.js";
export default {
    components: {
        jPop: () => import("@/components/zhaocai/jPop"),
    },
    data() {
        return {
            jShow: -1,
        };
    },
    props: {
        item: {
            type: Object,
        },
        index: {
            type: Number,
        },
        type:{
            type: Number,
        }
    },
    computed: {
        itemData: function(){
            let arr = []
            this.item.goodsList && this.item.goodsList.map((list, index) => {
                let objData = {};
                list && list.map((itt, i) => {
                    objData[itt.name] = itt.value;
                })
                arr.push(objData)
            })
            return arr
        }
    },
    mounted() {},
    methods: {
        jMover(i) {
            this.jShow = i;
        },
        // 函询
        inByLetDialogClick(e, s) {
            this.$emit("inByLetDialogClick", e, s);
        },
        goNewDetail(val, id,state) {
            // 招标预告跳转
           	if(state == 8){
				window.open(val+'?id='+id)
			}else{
				window.open('/hotTenderMachineLaborDetail?no='+id)
			}
        },
        getMoney(val) {
            if (val >= 10000) {
                return (
                    (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) +
                    "万元"
                );
            } else {
                return val + "元";
            }
        },
        getBackground(status) {
            let str = "";
            switch (status) {
                case 1:
                    str = "#F7AB01";
                    break;
                case 2:
                    str = "#0286DF";
                    break;
                case 3:
                    str = "#78C06E";
                    break;
                case 4:
                    str = "#969696";
                    break;
                case 5:
                    str = "#969696";
                    break;
                case 6:
                    str = "#0286DF";
                    break;
                case 8:
                    str = "#409ee9";
                    break;
                case 9:
                    str = "#78C06E";
                    break;
                case 10:
                    str = "#F7AB01";
                    break;
                default:
                    str = "#969696";
                    break;
            }
            return str;
        },
    },
    filters: {
        dealStatus(status) {
            // 招标状态
            let str = "";
            switch (status) {
                case 1:
                    str = "待招标";
                    break;
                case 2:
                    str = "招标中";
                    break;
                case 3:
                    str = "评标中";
                    break;
                case 4:
                    str = "招标结束";
                    break;
                case 5:
                    str = "废标";
                    break;
                case 6:
                    str = "招标中";
                    break;
                case 8:
                    str = "待报名";
                    break;
                case 9:
                    str = "报名中";
                    break;
                case 10:
                    str = "资格审查中";
                    break;
                default:
                    break;
            }
            return str;
        },
    },
    created() {},
};
</script>
<style lang="scss" scoped>
.tenderItem {
    box-sizing: border-box;
    float: left;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 568px;
    height: 335px;
    &:nth-child(even) {
        margin-right: 0;
    }
    &:hover {
        border-bottom: none;
        transform: translateY(-19px);
        transition: all 0.2s ease-in-out;
        .footer {
            height: 72px;
        }
    }
    .head {
        height: 68px;
        width: 100%;
        background: #f5f7fa;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        border-bottom: 1px solid #e4e7ed;
        .title {
            width: 490px;
            height: 28px;
            line-height: 25px;
            padding-top: 10px;
            margin-left: 10px;
            font-size: 16px;
            color: #333;
            font-weight: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .titleInfo {
            font-size: 14px;
            .moneySpan {
                color: #666666;
                margin-left: 10px;
            }
        }
        .i-status {
            display: block;
            position: absolute;
            top: 0;
            right: 0;
        }

    }
    .body {
        height: 154px;
        box-sizing: border-box;
        width: calc(100% - 20px);
        border-bottom: 1px dashed #e4e7ed;
        margin: 0px 10px;
        overflow: hidden;
    }
    /deep/.body .el-table td {
        padding: 7px 0;
        border: 0;
    }
    /deep/.body .el-table th {
        padding: 7px 0;
        border: 0;
    }
    /deep/.el-table:before {
        height: 0;
    }
    .footer {
        height: 110px;
        padding: 20px 10px;
        font-size: 14px;

        p {
            margin-bottom: 10px;
            color: #333;
            img {
                width: 14px;
                height: 17px;
                vertical-align: text-bottom
            }
            span {
                color: #666;
            }
        }
    }
}
.line {
    border: 1px solid #b79255 !important;
}
.noshuju{
    text-align: center;
    img{
        padding-top:25px;
        padding-bottom: 9px;
    }
    .text-info{
        font-size: 14px;
        color: #666666;
    }
}
</style>
